import { REMOVE_TIME, SET_TIME } from "../../consts/strings";
import { memo, useEffect, useState } from "react";

import StyledChip from "../DayChips/StyledChip";
import { each } from "lodash";
import {
  getRegularRoutersByTimeBands,
  matrixProfileLockSelector,
} from "../../reducers/matrixProfile/selectors";
import { getValueLabelValue } from "../../utils/timeSlider";
import { palette } from "../../theme/palette";
import { updateWaves } from "../../utils/waves";
import { useSelector } from "react-redux";

export const SetRemoveTimeButton = memo(
  ({ value, waves, onChange, onError }) => {
    const [isValueOnWave, setIsValueOnWave] = useState(false);
    const routesByTimeband = useSelector(getRegularRoutersByTimeBands);
    const matrixProfileLock = useSelector(matrixProfileLockSelector);

    useEffect(() => {
      setIsValueOnWave(false);
      each(waves, (wave) => {
        const labelValue = getValueLabelValue(value);
        if (wave.waveTime === labelValue) {
          setIsValueOnWave(true);
        }
      });
    }, [value, waves]);

    const onClick = () => {
      if (!!routesByTimeband[value]) {
        return onError();
      }
      const { waves: newWaves } = updateWaves({
        waves,
        time: getValueLabelValue(value),
      });
      onChange(newWaves);
    };

    return (
      <div>
        <StyledChip
          size={"small"}
          backgroundColour={
            isValueOnWave ? palette.btn.yellowFill : palette.btn.greenFill
          }
          clickable
          disabled={
            matrixProfileLock.lockedByUserCode && !matrixProfileLock.lockedByYou
          }
          label={isValueOnWave ? REMOVE_TIME : SET_TIME}
          onClick={onClick}
          width={isValueOnWave ? 75 : 55}
        />
      </div>
    );
  }
);
